import { render, staticRenderFns } from "./AutoShutdownDetails.vue?vue&type=template&id=3ae41747"
import script from "./AutoShutdownDetails.vue?vue&type=script&lang=ts"
export * from "./AutoShutdownDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports